export const readableDevelopmentTypes = {
  COVERED_AREA: 'plot-valuation.conversion.development-types.covered-area',
  NOW: 'plot-valuation.conversion.development-types.now',
  NEAR_FUTURE: 'plot-valuation.conversion.development-types.near-future',
  RESTRICTED: 'plot-valuation.conversion.development-types.restricted',
  NONE: 'plot-valuation.conversion.development-types.none',
  UNKNOWN: 'plot-valuation.conversion.development-types.unknown',
}
